import { cn } from 'cn';

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  ref?: React.Ref<HTMLInputElement>;
}

/**
 * @deprecated Use `Input` from `@/ui` for new work — the Radix-free,
 * shadcn-sourced design system. See `.agents/rules/project.md` →
 * "Shared Library Reuse". Kept for existing call sites; do not use in new UI.
 */
function Input({ className, ref, ...props }: Props) {
  return (
    <input
      data-test='input'
      className={cn(
        'flex h-10 w-full rounded-md border bg-white px-3 py-2 text-base/normal font-normal text-gray-900 file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-sm/tight placeholder:text-gray-400 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
        className
      )}
      ref={ref}
      {...props}
    />
  );
}

export default Input;
